import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SectionTitle from '@src/components/SectionTitle';
import { MultipleLocations } from '../MultipleLocations';
import './styles.scss';

const LOCATIONS_LIMIT = 5;

export class TargetLocation extends Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    isFullWidth: PropTypes.bool.isRequired,
    onLocationSelected: PropTypes.func.isRequired,
    opening: PropTypes.object.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    // Remove predicted location objects
    const prevLocations = this.props.opening.targetLocations.filter(item => item.id);
    const nextLocations = nextProps.opening.targetLocations.filter(item => item.id);

    return prevLocations !== nextLocations || this.props.invalid !== nextProps.invalid;
  }

  render() {
    const { opening, onLocationSelected, isFullWidth } = this.props;

    return (
      <div className={classnames('target-location', isFullWidth && 'target-location--full-width')}>
        <SectionTitle
          className="target-location__section-title"
          size="M"
          subtitle="Where would you like to notify applicants"
          title="Target location"
        />

        <MultipleLocations
          defaultLocations={opening.targetLocations}
          limit={LOCATIONS_LIMIT}
          onLocationSelected={onLocationSelected}
        />
      </div>
    );
  }
}
